import { render, staticRenderFns } from "./VLetShForm.vue?vue&type=template&id=2d1ca565"
import script from "./VLetShForm.vue?vue&type=script&lang=js"
export * from "./VLetShForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports